import { API_CONFIG, apiUtils } from '../config.js';


export const whatsappAnalyticsApi = {
  getSummary: async (params) => {
    const queryString = apiUtils.buildQueryString(params);
    const url = `${API_CONFIG.BASE_URL}/whatsapp/analytics/summary?${queryString}`;
    
    return await apiUtils.makeAuthenticatedRequest(url, {
      method: 'GET',
    });
  },

  getTimeline: async (params) => {
    const queryString = apiUtils.buildQueryString({
      ...params,
      granularity: params.granularity || 'day'
    });
    const url = `${API_CONFIG.BASE_URL}/whatsapp/analytics/timeline?${queryString}`;
    
    return await apiUtils.makeAuthenticatedRequest(url, {
      method: 'GET',
    });
  },

  getLast7Days: async () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);

    return whatsappAnalyticsApi.getSummary({
      start_date: startDate.toISOString().split('T')[0],
      end_date: endDate.toISOString().split('T')[0]
    });
  },

  getLast30Days: async () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);

    return whatsappAnalyticsApi.getSummary({
      start_date: startDate.toISOString().split('T')[0],
      end_date: endDate.toISOString().split('T')[0]
    });
  }
};

export default whatsappAnalyticsApi;
